<div style="background: white;">
  <section class="bg-size">
    <div class="block no-padding">
      <div class="container-fluid" *ngIf="appointment_details">
        <div class="row">
          <div class="col-md-12 mt-3" style="margin-bottom: 30px;">
            <div class="px-4 pt-2">
              <h6 class="card-title job-description1 m-0 mb-3 p-0" *ngIf="!disable_action">
                {{appointment_details.headerText}}
              </h6>
              <div class="pt-2">
                <div class="row">
                  <div class="col-md-8">
                    <ng-container *ngIf="appointment_details.fileData && reset_embed_tag">
                      <object id="resumeViewer" frameborder="0" style="width: 100%;height: 100%;"
                        [data]="appointment_details.fileData | SafeFilePipe">
                      </object>
                    </ng-container>


                    <!-- <p>Your web browser doesn't have a PDF plugin.
                        Instead you can
                        <a [attr.href]="appointment_details.fileData" [attr.download]="appointment_details.fileName">click here </a>
                        to
                        download the file.
                      </p> -->
                    <!-- </object> -->
                  </div>
                  <div class="col-md-4">
                    <div class="card-box-shadow">
                      <div class="appointment-info-header">
                        Appointment Information
                      </div>
                      <div class="px-4 py-3">
                        <div class="mb-1 appointment-info"
                          *ngIf="appointment_details && appointment_details.joiningDate">
                          <span class="appointment-info-title">
                            Date of Joining
                          </span>
                          <span class="appointment-info-details" [title]="appointment_details.joiningDate">
                            {{appointment_details.joiningDate | UtcToLocalTime | date: 'dd-MMM-yyyy h:mm a'}}
                          </span>
                        </div>

                        <div class="mb-1 appointment-info"
                          *ngIf="appointment_details && appointment_details.designationTitle">
                          <span class="appointment-info-title">
                            Designation <span *ngIf="appointment_details && appointment_details.grade"> (Grade) </span>
                          </span>
                          <span class="appointment-info-details" [title]="appointment_details.designationTitle">
                            {{appointment_details.designationTitle}}
                            <span *ngIf="appointment_details && appointment_details.grade">
                              ({{appointment_details.grade}})
                            </span>
                          </span>
                        </div>

                        <div class="mb-1 appointment-info"
                          *ngIf="appointment_details && appointment_details.employeeCode">
                          <span class="appointment-info-title">
                            Employee Code
                          </span>
                          <span class="appointment-info-details" [title]="appointment_details.employeeCode">
                            {{appointment_details.employeeCode}}
                          </span>
                        </div>
                        <div class="mb-1 appointment-info" *ngIf="appointment_details && appointment_details.location">
                          <span class="appointment-info-title">
                            Location
                          </span>
                          <span class="appointment-info-details" [title]="appointment_details.location">
                            {{appointment_details.location}}
                          </span>
                        </div>

                        <div class="mb-1 appointment-info"
                          *ngIf="appointment_details && appointment_details.reportingManager">
                          <span class="appointment-info-title">
                            Reporting Manager
                          </span>
                          <span class="appointment-info-details" [title]="appointment_details.reportingManager">
                            {{appointment_details.reportingManager}}
                          </span>
                        </div>



                        <div class="mb-1 appointment-info"
                          *ngIf="appointment_details && appointment_details.appointmentedCTC && appointment_details.appointmentedCTC != '  '">
                          <span class="appointment-info-title">
                            Appointmented Salary
                          </span>
                          <span class="appointment-info-details" [title]="appointment_details.appointmentedCTC">
                            {{appointment_details.offeredCTCCurrencyTitle}}
                            {{appointment_details.offeredCTC}}
                            {{appointment_details.offeredCTCDurationTitle}}
                          </span>
                        </div>
                        <div class="mb-1 appointment-info"
                          *ngIf="appointment_details && appointment_details.appointmented_datetime && appointment_details.appointmented_datetime != '  '">
                          <span class="appointment-info-title">
                            Appointmented on
                          </span>
                          <span class="appointment-info-details" [title]="appointment_details.appointmented_datetime">
                            {{appointment_details.appointmented_datetime | UtcToLocalTime | date: 'dd-MMM-yyyy h:mm a'}}
                          </span>
                        </div>
                      </div>

                      <div class="p-2 appointment-letter-view-btn">
                        <p (click)="termsConditions()" *ngIf="!disable_action" class="text-center">
                          <input id="field_terms" type="checkbox" [(ngModel)]="terms_conditions" name="terms">
                          <label class="ml-2 d-inline" for="field_terms">
                            {{appointment_details.termsText}}
                          </label>
                        </p>
                        <div *ngIf="!disable_action" style="text-align: center">
                          <ng-container *ngIf="sign_upload_type == 1 || !sign_upload_type;">
                            <app-digital-signature form_control="signature" [form_group]="digital_signature_form"
                              [label]="'OFFER.signature' | translate"
                              [placeholder]="'OFFER.signature_placeholder' | translate" width="100%" [height]="150">
                            </app-digital-signature>
                          </ng-container>
                          <ng-container *ngIf="sign_upload_type == 2;">
                            <app-file-upload-and-preview form_control="signature" [form_group]="digital_signature_form"
                              [label]="'OFFER.signature' | translate"
                              [placeholder]="'OFFER.signature_upload' | translate" width="100%" [height]="150">
                            </app-file-upload-and-preview>
                          </ng-container>

                          <div class="link mb-2 text-center" (click)="toggleSignatureType()">
                            {{
                            (sign_upload_type && sign_upload_type == 2 ?'OFFER.digital_sign' : 'OFFER.upload_sign')
                            |translate
                            }}
                          </div>
                        </div>

                        <div *ngIf="disable_action" style="text-align: center">

                          <app-file-upload-and-preview form_control="signature" [form_group]="digital_signature_form"
                            [label]="'OFFER.signature' | translate" [placeholder]="'OFFER.signature_upload' | translate"
                            width="100%" [height]="150" [disabled]="disable_action">
                          </app-file-upload-and-preview>


                          <div class="link mb-2 text-center" (click)="toggleSignatureType()" *ngIf="!disable_action">
                            {{
                            (sign_upload_type && sign_upload_type == 2 ?'OFFER.digital_sign' : 'OFFER.upload_sign')
                            |translate
                            }}
                          </div>
                        </div>

                        <!-- <div class="text-center action-taken" *ngIf="disable_action && appointment_details">
                          <span *ngIf="!(appointment_details.appLetterAcceptance)">
                            An action was taken
                            <span *ngIf="appointment_details.appointment_accepted_datetime">
                              on
                              {{appointment_details.appointment_accepted_datetime}}
                            </span>
                          </span>
                          <span *ngIf="(appointment_details.appLetterAcceptance > 0  )">
                            You have
                            <span *ngIf="appointment_details.appLetterAcceptance == 1">
                              accepted
                            </span>
                            <span *ngIf="appointment_details.appLetterAcceptance == 2">
                              declined
                            </span>
                            the appointment
                            <span *ngIf="appointment_details.appointmentAcceptedDate">
                              on
                              {{
                              appointment_details.appointmentAcceptedDate | UtcToLocalTime | date: 'dd-MMM-yyyy h:mm a'
                              }}
                            </span>
                          </span>

                        </div> -->
                        <div class="text-center action-taken" *ngIf="disable_action && appointment_details">
                          <!-- <span *ngIf="!(offer_details.offerAcceptance)">
                            An action was taken
                            <span *ngIf="offer_details.offer_accepted_datetime">
                              on
                              {{offer_details.offer_accepted_datetime}}
                            </span>
                          </span> -->
                          <span>
                            You have
                            <!-- <span *ngIf="offer_details.offerAcceptance == 1">
                              accepted
                            </span>
                            <span *ngIf="offer_details.offerAcceptance == 2">
                              declined
                            </span> -->
                            <span *ngIf="appointment_details.actionTakenText">
                              {{appointment_details.actionTakenText}}
                            </span>
                            the receipt of appointment letter
                            <span *ngIf="appointment_details.appAcceptedDate">
                              on
                              {{appointment_details.appAcceptedDate | UtcToLocalTime | date: 'dd-MMM-yyyy h:mm a'}}
                            </span>

                            <span *ngIf="appointment_details.appointmentIP">
                              on the device having IP {{appointment_details.appointmentIP}}
                            </span>
                          </span>

                        </div>
                        <div *ngIf="!disable_action" class="text-center">
                          <!-- <button type="button" class="btn btn-outline-danger btn-sx appointment-buttons"
                            (click)="submitAppointmentAcceptance(2)" *ngIf="!appointment_details.disableDeclineAction">
                            {{'BTN.decline' | translate}}
                          </button> -->
                          <button class="btn btn-primary btn-sx ml-3 appointment-buttons" type="button"
                            (click)="submitAppointmentAcceptance(1)">
                            {{'BTN.submit' | translate}}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!appointment_details" class="err_message">
        {{error_message}}
      </div>
    </div>
  </section>
</div>
